import React from 'react'
import Layout from 'antd/lib/layout'
import UserHeaderMenu from '@components/Layouts/HeaderMenu'
import TopbarMenu from './Menu'
import styles from './index.scss'

function TopNavigation({ showUserGuide, showVideoGuide }) {
    return (
        <Layout.Header className={styles['top-navigation']}>
            <TopbarMenu />
            <UserHeaderMenu showUserGuide={showUserGuide} showVideoGuide={showVideoGuide} />
        </Layout.Header>
    )
}
export default TopNavigation
